import React from "react";
import LeftNavSubmenuItem from "./LeftNavSubmenuItem";

export default function LeftNavSubmenuItemGroup(props) {
  const { item: el, insideRouter } = props;
  const children = (el.subitems || []).map((el2, idx) => (
    <LeftNavSubmenuItem item={el2} key={idx} insideRouter={insideRouter} />
  ));
  return (
    <React.Fragment>
      <li>
        <span>{el.label}</span>
      </li>
      <li className="divider" />
      <li>{children}</li>
    </React.Fragment>
  );
}
